export default __webpack_public_path__ + "ee58e3f46549272e02f6d4655d28cdbc.svg";